<div class="selector-shell" [class.selector-shell--error]="!!errorKey">
  <!-- subscriptSizing="dynamic" collapses the empty subscript wrapper: this
       control renders its error outside the form field (see below), so the
       reserved hint/error row would otherwise add dead space under the field. -->
  <mat-form-field class="full-width" floatLabel="never" subscriptSizing="dynamic">
    <div class="independent-display-text" [class.hint-text]="!selected">
      <span class="item-name">{{ displayName }}</span>
      <span *ngIf="selected?.tag" class="item-badge" [ngClass]="'badge-' + selected.tag.type">
        {{ selected.tag.label | translate }}
      </span>
    </div>
    <mat-select
      [attr.aria-label]="ariaLabel"
      tsMatSelectInfiniteScroll
      (lastItemReached)="lastItemReached.emit()"
      [compareWith]="checkIfItemIsSelected"
      [value]="selected"
      (selectionChange)="selectionChanged($event.value)"
      [attr.data-cy]="dataCy"
    >
      <mat-select-trigger class="transparent-trigger">
        <!-- Transparent trigger - actual text is displayed independently above -->
      </mat-select-trigger>

      <div class="sticky-header" *ngIf="searchable">
        <ts-search-bar
          class="flex-grow-1 search-bar-margin"
          [searchValue]="searchTerm"
          (searchChanged)="searchTermChanged.emit($event)"
        ></ts-search-bar>
        <mat-divider></mat-divider>
      </div>

      <!-- Item options -->
      <mat-option *ngFor="let item of allOptions" [value]="item">
        <span class="option-content">
          <span class="item-name">{{ getDisplayValue(item) }}</span>
          <span *ngIf="item.tag" class="item-badge" [ngClass]="'badge-' + item.tag.type">
            {{ item.tag.label | translate }}
          </span>
        </span>
      </mat-option>

      <!-- Hidden option to allow dropdown to open when no items -->
      <mat-option
        *ngIf="loaded && (!allOptions || allOptions.length === 0)"
        disabled
        style="display: none"
      ></mat-option>

      <!-- Loading indicator -->
      <div *ngIf="!loaded" class="spinner-container">
        <mat-spinner diameter="24"></mat-spinner>
      </div>

      <!-- No items message -->
      <div
        class="flex-row align-items-center justify-content-center"
        style="margin: 0 auto; padding: 48px"
        *ngIf="loaded && (!allOptions || allOptions.length === 0)"
      >
        {{ noItemsMessage || ('info.no_items' | translate) }}
      </div>
    </mat-select>
  </mat-form-field>
</div>

<div *ngIf="errorKey" class="selector-error-message" role="alert">
  <i class="ri-error-warning-line" aria-hidden="true"></i>
  <span>{{ errorKey | translate }}</span>
</div>
